import React from "react";
import { useLocation } from "react-router-dom";
// import {
//   useGetContactDetailsQuery,
//   useSubmitSubscribeMutation,
// } from "../Store/api/CommonApi";
// import { error, success } from "../Services/CommonService";
// import { InstagramEmbed } from "react-social-media-embed";

export default function Footer() {
   const {pathname} = useLocation();
   //console.log(pathname);
   
  //   const [contact, setContact] = useState({});
  //   const [submitSubscribe] = useSubmitSubscribeMutation();
  //   const contactApi = useGetContactDetailsQuery();
  //   const handleSubmit = useCallback(
  //     (e) => {
  //       e.preventDefault();
  //       const formData = new FormData(e.target);
  //       let data = Object.fromEntries(formData);
  //       submitSubscribe(data)
  //         .then((res) => {
  //           if (res.data?.code === "success") {
  //             e.target.reset();
  //             success(res.data?.message);
  //           } else {
  //             error("Request not submission failed.");
  //           }
  //         })
  //         .catch((err) => console.log(err));
  //     },
  //     [submitSubscribe]
  //   );

  //   useEffect(() => {
  //     if (contactApi?.data?.data) {
  //       setContact(contactApi?.data?.data);
  //     }
  //   }, [contactApi?.data, setContact]);
//console.log(pathname.startsWith('/rise/'));

  return (
    <footer className="bg-gray-100 border-t py-6">
      <div className="max-w-6xl mx-auto px-6 text-center text-sm text-gray-600">
        <p className="mb-2">© 2026 Pride Circle. All rights reserved.</p>
        {(pathname!='/employer' && pathname.startsWith('/rise/')==false) && (<p className="text-gray-500">
          Disclaimer: Pride Circle connects job seekers with inclusive
          employers. We do not guarantee job placement and are not responsible
          for hiring decisions made by employers.
        </p>)}
      </div>
    </footer>
  );
}
